import type { FC, ReactNode } from 'react'

import { useState } from 'react'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { SongProvider } from '@/components/landing/song-provider'
import HeroSection from '@/components/landing/hero-section'
import SiteFooter from '@/components/landing/site-footer'
import SongSection from '@/components/landing/song-section'
import StorySection from '@/components/landing/story-section'
import GamesSection from '@/components/landing/games-section'
import SurpriseGate from '@/components/landing/surprise-gate'
import FinaleSection from '@/components/landing/finale-section'
import LetterSection from '@/components/landing/letter-section'
import GallerySection from '@/components/landing/gallery-section'
import ReasonsSection from '@/components/landing/reasons-section'
import PromisesSection from '@/components/landing/promises-section'
import FloatingSongPill from '@/components/landing/floating-song-pill'
import VideoMemoriesSection from '@/components/landing/video-memories-section'
import { PHOTOS } from '@/constants/birthday'

const Home: FC = (): ReactNode => {
    const [opened, setOpened] = useState(false)

    return (
        <SongProvider>
            <Seo ogImage={PHOTOS.photo6.src} />

            <SurpriseGate onOpen={() => setOpened(true)} />

            <Layout inert={!opened} footer={<SiteFooter />}>
                <HeroSection revealed={opened} />
                <StorySection />
                <GallerySection />
                <VideoMemoriesSection />
                <ReasonsSection />
                <LetterSection />
                <SongSection />
                <GamesSection />
                <PromisesSection />
                <FinaleSection />
            </Layout>

            <FloatingSongPill />
        </SongProvider>
    )
}

export default Home
